import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import QuickAddButton from './QuickAddButton';
import HelpWidget from './HelpWidget';
import OnboardingFlow from './OnboardingFlow';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const [showOnboarding, setShowOnboarding] = useState(false);
  const { user, setUser } = useAuth();

  useEffect(() => {
    // Check if user has completed onboarding
    // Use user email as key to ensure it's per-user and persists across sessions
    if (user?.email) {
      const userKey = `bissa_onboarding_completed_${user.email}`;
      const hasCompletedOnboarding = localStorage.getItem(userKey) === 'true';
      
      // Also check if user has onboarding_completed flag in their user object (from database)
      const dbCompleted = user.onboarding_completed === true;
      
      // Show onboarding only if user hasn't completed it (neither in localStorage nor database)
      if (!hasCompletedOnboarding && !dbCompleted) {
        // Small delay to let the dashboard load first
        const timer = setTimeout(() => {
          setShowOnboarding(true);
        }, 1000);
        return () => clearTimeout(timer);
      }
    }
  }, [user]);

  const handleOnboardingComplete = async () => {
    setShowOnboarding(false);
    // Refresh user data to get updated onboarding_completed flag from database
    try {
      const API = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/api`;
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true
      });
      if (response.data) {
        setUser(response.data);
      }
    } catch (err) {
      console.warn('Failed to refresh user data after onboarding completion:', err);
    }
  };

  return (
    <div className="bg-gray-50 dark:bg-gray-950 min-h-screen">
      <Sidebar />
      <Header />
      <main className="md:ml-64 pt-20 md:pt-28 p-4 md:p-6">
        {children}
      </main>
      <QuickAddButton />
      <HelpWidget />
      
      {/* Onboarding Flow */}
      <OnboardingFlow
        isOpen={showOnboarding}
        onClose={() => setShowOnboarding(false)}
        onComplete={handleOnboardingComplete}
      />
    </div>
  );
};

export default Layout;